import { Component, OnInit, ViewChild, QueryList, Input, Output, EventEmitter } from '@angular/core';
import { MsgModel } from '../../common-components/msg/model/msg.model';
import { WorkflowsService } from '../../system/workflows/service/workflows.service';
import { AccountRequestService } from '../../auth/service/account-request.service';
import * as _moment from 'moment';
import { default as _rollupMoment, Moment } from 'moment';
import { MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS } from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE, MatOption } from '@angular/material/core';
import { FormControl, FormGroup, UntypedFormBuilder, UntypedFormControl } from '@angular/forms';
import { AuthService } from 'src/app/component/auth/service/auth.service';
import { MatSelect } from '@angular/material/select';
import { WorkflowStateTypes } from '../../system/workflows/model/workflow-state-types.model';
import { RemoveIdPipe } from 'src/app/pipes/remove-id.pipe';
import { AccessService } from '../../navigation/service/access.service';

const moment = _rollupMoment || _moment;

export const MY_FORMATS = {
  parse: {
    dateInput: 'LL'
  },
  display: {
    dateInput: 'LL',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY'
  }
};

@Component({
  selector: 'app-manage',
  templateUrl: './manage.component.html',
  styleUrls: ['./manage.component.scss'],
  providers: [
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
    },

    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS }
  ]
})

export class ManageComponent implements OnInit {
  @Input() searchParam: any = [{}];
  scrName: string = "manage";
  accountRequestId: number;
  loadingWorkflows = false;
  loading: any[] = [];
  msg: MsgModel = {};
  workflows: any[] = [];
  states: any[] = [];
  show: { [key: string]: boolean } = {};
  control: any = {};
  coeWorkflow: any;
  coe2017Workflow: any;
  coe2023Workflow: any;
  chosenStateNames: WorkflowStateTypes[] = [];
  coeFiltersForm: FormGroup;
  loadingPromises: any[] = [];
  coeWorkflowStates: any = {};
  canReassignNode: boolean = false;
  canChangeNodeState: boolean = false;
  removeIdPipe = new RemoveIdPipe();
  workflowStateNames: WorkflowStateTypes[] = [];
  WorkflowStateTypes: WorkflowStateTypes[] = [];
 
  CoeStatus = [
    { value: 'Approved State', display: 'Approved' },
    { value: 'Denied State', display: 'COE Does Not Qualify' },
    { value: 'COE Ineligible State', display: 'COE Ineligible' },
    { value: 'Completion State', display: 'Completed' },
    { value: 'Creation State', display: 'Creation', },
    { value: 'Recruiter Fix State', display: 'Fix COE(s)' },
    { value: 'Self Review State', display: 'My Data Entry + Review' },
    { value: 'Removed Child State', display: 'Remove Child' },
    { value: 'Review State', display: 'Review' },
    { value: 'Second Reviewer State', display: 'Second Reviewer' },
    { value: 'Void State', display: 'Voided' },
  ];

  constructor(
    private workflowsService: WorkflowsService,
    private accountRequestService: AccountRequestService,
    private auth: AuthService,
    public accessService: AccessService,
    private _formBuilder: UntypedFormBuilder) {
    this.coeFiltersForm = this._formBuilder.group({
      coeNumber: [],
      id: [''],
      chosenStateNames: [],
      fromDateString: new FormControl(moment().subtract(30, 'days')),
      toDateString: new UntypedFormControl(null)
    });
  }

  ngOnInit(): void {
    this.init();
  }
  
  init() {
    this.loadingPromises = [];
    //$scope.shoppingCart.searchFields['show'] ? $scope.show = $scope.shoppingCart.searchFields['show'] : $scope.show = {};
    //$scope.shoppingCart.searchFields['workflows'] ? $scope.fromDateString = $scope.shoppingCart.searchFields['fromDateString'] : $scope.fromDateString.setDate($scope.fromDateString.getDate() - 30);
    //$scope.shoppingCart.searchFields['toDateString'] ? $scope.toDateString = $scope.shoppingCart.searchFields['toDateString'] : $scope.toDateString = undefined;
    this.getPermissions();
    this.getCOEWorkflowSates(this.workflows);
    this.getWorkflows();
  }

  getWorkflows() {
    this.loadingWorkflows = true;
    this.workflowsService.index().subscribe({
      next: (res) => {
        this.workflows = res.workflows;
        this.workflows = this.workflows.filter((wf) => wf.NAME.indexOf('Enrollment') === -1) // Removing enrollment from the Workflow list
        this.workflows.filter((wf) => wf.NAME.indexOf('COE') === -1 &&  wf.NAME.indexOf('Enrollment') === -1).forEach((workflow) => {
          this.control[workflow.WORKFLOW_NODE_TYPES.NAME] = {};
          this.getWorkflowStates(workflow);
        });

        // Create scope variables for Workflows that will be used in filters
        this.coeWorkflow = this.getWorkflow('COE Workflow');
        this.coe2017Workflow = this.getWorkflow('COE-2017 Workflow');
        this.coe2023Workflow = this.getWorkflow('COE-2023 Workflow');
      },
      error: (err) => {
        this.msg = { SUCCESS: false, MSG: 'Error retrieving Workflow.' };
      },
      complete: () => {
        this.loadingWorkflows = false;
      }
    });
  }

  getWorkflowStates(workflow: any)  {
    //console.log("Inside getWorkflowStates only with workflow object")
    this.workflowsService.getWorkflowStates(workflow.ID).subscribe({
      next: (res) => {
          if (res.states) {
            const stateKey = workflow.WORKFLOW_NODE_TYPES.NAME + 'States';
            this.control[stateKey] = {};
            const orderedStates = res.states.sort((a: any, b: any) => a.DESCRIPTION.localeCompare(b.DESCRIPTION));
            orderedStates.forEach((state: any) => {
              this.control[stateKey][state.DESCRIPTION] = {
                ENABLE: false,
                DISABLED: false,
                NAME: state.NAME,
				DESCRIPTION: state.DESCRIPTION
              };
            });
          }
        },
      error: (err) => {
        this.msg = { SUCCESS: false, MSG: 'Error retrieving Workflow.' };
      },
      complete: () => {
        //this.loadingWorkflows = false;
      }
    });
  }

  getWorkflowStates_Click(workflowID: number, workflowIndex: number) {
    this.loadingWorkflows = true;
    this.loading[workflowID] = true;
    //saveSearchFields() need to be implemented to use in shopping cart
    this.searchParam.id = workflowID;
    if (this.WorkflowStateTypes && this.WorkflowStateTypes.length > 0)
    {
      this.searchParam.chosenStateNames = this.WorkflowStateTypes.map((state: any) => state.value.NAME);
    }
    else
        this.searchParam.chosenStateNames = this.coeFiltersForm.get('chosenStateNames')?.value;

    this.searchParam.coeNumber = this.coeFiltersForm.get('coeNumber')?.value;
    this.searchParam.fromDateString = this.coeFiltersForm.get('fromDateString')?.value?.toISOString();
    this.searchParam.toDateString = this.coeFiltersForm.get('toDateString')?.value?.toISOString();

    this.workflowsService.getWorkflowStateNodes(this.searchParam).subscribe({
      next: (res) => {
        if (!workflowIndex) {
         //this.workflows.filter((wf) => wf.NAME.indexOf('COE') === -1).forEach((workflow) => {  --need to convert this line to anular 17
        }
        if (res?.states) {
          this.states = JSON.parse(res.states)
          this.workflows[workflowIndex].states = this.cleanState(this.states);
        }
        else if (res.msg) {
          this.workflows[workflowIndex].states = [];
        }
      },
      error: (err) => {
        this.msg = { SUCCESS: false, MSG: 'Error retrieving WorkflowStates.' };
      },
      complete: () => {
        this.loading[workflowID] = false;
        this.loadingWorkflows = false;
      }
    });
  }

  getCOEWorkflowSates(workflow: any) {
    console.log("getCOEWorkflowSates")
    this.workflowsService.getWorkflowStates(7).subscribe({
      
      next: (res) => {
        if (res.states) {
          const orderedStates = res.states.sort((a: any, b: any) => a.DESCRIPTION.localeCompare(b.DESCRIPTION));
          orderedStates.forEach((state: any) => {
            this.coeWorkflowStates[state.DESCRIPTION] = {
              ENABLE: false,
              DISABLED: false,
              NAME: state.NAME
            };
          });

          this.workflowsService.getWorkflowStates(8).subscribe({
            next: (res) => {
              if (res.states) {
                const orderedStates = res.states.sort((a: any, b: any) => a.DESCRIPTION.localeCompare(b.DESCRIPTION));
                orderedStates.forEach((state: any) => {
                  this.coeWorkflowStates[state.DESCRIPTION] = {
                    ENABLE: false,
                    DISABLED: false,
                    NAME: state.NAME
                  };
                });
              }
            },
          });
        }
      },
      error: (err) => {
        this.msg = { SUCCESS: false, MSG: 'Error retrieving Workflow.' };
      },
      complete: () => {
        //this.loadingWorkflows = false;
      }
    });
  }

  getWorkflowNodeCount(workflow: any): number {
    let count = 0;
    // Use forEach to loop through states
    if (workflow.states) {
      workflow.states.forEach((state: any) => {
        if (state.NODES) {
          count += state.NODES.length;
        }
      });
    }
    return count;
  }

  cleanState(states: any[]): any[] {
    let createdBy = "---";
    let createdDate = "";
    let lastUpdatedBy = "---";
    let lastUpdatedDate = "";
    states.forEach(state => {
      state.NODES.forEach((node: {
        CREATED_DATE: string;
        NODE_HISTORIES: string | any[];
        lastestUpdatedDate: any;
        createdToolTip: string;
        updatedToolTip: string;
        regionName: string;
        NODE_COES: string | any[];
        NODE_REGIONS: string | any[];
        NODE_PROVISIONAL_SCHOOLS: string | any[];
        NODE_ACCOUNT_REQUESTS: string | any[];
        NODE_CREATORS: string | any[];
      }) => {

        createdDate = this.getTimeDifferenceinHours(new Date(node.CREATED_DATE));
        node.CREATED_DATE = this.simpleDateTime(node.CREATED_DATE);
        if (node.NODE_HISTORIES && node.NODE_HISTORIES.length > 0) {
          const latestHistory = node.NODE_HISTORIES[node.NODE_HISTORIES.length - 1];
          lastUpdatedDate = this.getTimeDifferenceinHours(new Date(latestHistory.CREATED_DATE));
          latestHistory.CREATED_DATE = this.simpleDateTime(latestHistory.CREATED_DATE);
          node.lastestUpdatedDate = latestHistory.CREATED_DATE;
          if (latestHistory.LOGIN_DETAILS)
            lastUpdatedBy = latestHistory.LOGIN_DETAILS?.PERSON?.FIRST_NAME + " " + latestHistory?.LOGIN_DETAILS?.PERSON?.LAST_NAME + " (" + latestHistory?.LOGIN_DETAILS?.USER_ID + ")";
        }
        if (node.NODE_ACCOUNT_REQUESTS && node.NODE_ACCOUNT_REQUESTS.length > 0 && node.NODE_ACCOUNT_REQUESTS[0]?.ACCOUNT_REQUESTS.ID) {
          this.accountRequestId = node.NODE_ACCOUNT_REQUESTS[0].ACCOUNT_REQUESTS.ID;
          this.accountRequestService.showDetails(this.accountRequestId).subscribe({
            next: (res) => {
              node.NODE_ACCOUNT_REQUESTS[0].ACCOUNT_REQUESTS.FIRST_NAME = res.accountRequest.FIRST_NAME;
              node.NODE_ACCOUNT_REQUESTS[0].ACCOUNT_REQUESTS.LAST_NAME = res.accountRequest.LAST_NAME;
              node.NODE_ACCOUNT_REQUESTS[0].ACCOUNT_REQUESTS.EMAIL_ADDRESS = res.accountRequest.EMAIL_ADDRESS;
            },
            error: (err) => {
              this.msg = { SUCCESS: false, MSG: 'Error retrieving accountRequestService showDetails.' };
            },
            complete: () => {
            }
          });
        }
        if (node.NODE_CREATORS && node.NODE_CREATORS.length > 0) {
          createdBy = node.NODE_CREATORS[0]?.LOGIN_DETAILS?.PERSON?.FIRST_NAME + " " + node.NODE_CREATORS[0]?.LOGIN_DETAILS?.PERSON?.LAST_NAME + " (" + node.NODE_CREATORS[0]?.LOGIN_DETAILS?.USER_ID + ")";
        }
        if (createdDate != "") {
          node.createdToolTip = "Created " + createdDate + " ago\n Created by: " + createdBy
        }
        if (lastUpdatedDate != "") {
          node.updatedToolTip = "Last Updated " + lastUpdatedDate + " ago\n Last Updated by: " + lastUpdatedBy
        }
        if (node.NODE_REGIONS && node.NODE_REGIONS.length > 0) {
          node.regionName = node.NODE_REGIONS[0].REGION.NAME;
        }
      });
    });
    //console.log("states", states)
    return states;
  }

   
  outputEventEmitter(workflowStateTypes: WorkflowStateTypes[]) {
    this.WorkflowStateTypes = workflowStateTypes;
    //console.log("this.workflowStateNames", this.WorkflowStateTypes)
}
  getTimeDifferenceinHours(targetDate: Date): string {
    const now = new Date();
    const differenceInMilliseconds = now.getTime() - targetDate.getTime();
    const days = Math.floor(differenceInMilliseconds / (1000 * 60 * 60 * 24));
    const remainingMilliseconds = differenceInMilliseconds % (1000 * 60 * 60 * 24);
    const hours = Math.floor(remainingMilliseconds / (1000 * 60 * 60));
    if (hours == 0)
      return `${days} days, ${hours} hour`;
    else
      return `${days} days, ${hours} hours`;
  }

  simpleDateTime(date: string): string {
    return date; // Replace with actual formatted date
  }

  toggleShow(obj: any) {
    obj.SHOW = !obj.SHOW;
  }

  isLoading(id: number) {
    if (this.loading[id]) {
      return true;
    }
    return false;
  }

  expandAll(): void {
    this.workflows.forEach(workflow => {
      workflow.SHOW = true;
      if (workflow.states) {
        workflow.states.forEach((state: any) => {
          state.SHOW = true;
        });
      }
    });
  }

  collapseAll(): void {
    this.workflows.forEach(workflow => {
      workflow.SHOW = false;
      if (workflow.states) {
        workflow.states.forEach((state: any) => {
          state.SHOW = false;
        });
      }
    });
  }

  toggleAllSelection(matSelect: MatSelect, toggle: boolean) {
    if (toggle) matSelect.options.forEach((item: MatOption) => item.select());
    else matSelect.options.forEach((item: MatOption) => item.deselect());
  }

  getWorkflow(workflowName: string) {
    for (var i = 0; i < this.workflows.length; i++) {
      if (this.workflows[i].NAME == workflowName) {
        return this.workflows[i];
      }
    }
  }

  searchCOEWorkflow() {
    this.coeWorkflow.SHOW = true;
    this.coe2017Workflow.SHOW = true;
    this.coe2023Workflow.SHOW = true;

    this.getWorkflowStates_Click(this.coeWorkflow.ID, this.workflows.indexOf(this.coeWorkflow));
    this.getWorkflowStates_Click(this.coe2017Workflow.ID, this.workflows.indexOf(this.coe2017Workflow));
    this.getWorkflowStates_Click(this.coe2023Workflow.ID, this.workflows.indexOf(this.coe2023Workflow));
  }

  resetCOEFilters() { 
    this.coeFiltersForm.get('coeNumber')?.setValue(null)
    this.coeFiltersForm.get('chosenStateNames')?.setValue(null)
 }

  clearDates(): void {
    this.coeFiltersForm.get('fromDateString')?.setValue(null)
    this.coeFiltersForm.get('toDateString')?.setValue(null)
  }

  getPermissions() {
    //this.accessService.featureAccessible('Reassign Node').subscribe((x) => {if (x) {this.canReassignNode = x; }});
    //this.accessService.featureAccessible('Change Node State').subscribe((x) => {if (x) {this.canChangeNodeState = x; }});
  }

  getWorkflowStateDefinition(workflow: any): any {
    const workflowType = workflow?.WORKFLOW_NODE_TYPES.NAME + 'States';
    if (workflowType) {
      //console.log("workflow type", workflowType)
      //console.log("this.control[workflowType]",this.control[workflowType])
      return this.control[workflowType];
    }
    else {
      console.error(`Property ${workflowType} not found on workflow.`);
      return null;
    }
  }

    

}


